import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-icon-reset",
  "use": "app-icon-icon-reset-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"app-icon-icon-reset\"><path d=\"M12.5 10.2H9.3L11.5 8l-1-1-3.9 3.9 1 1 2.9 2.9 1-1-2.3-2.3h3.3c1.5 0 2.1 1.2 2.1 2.8H16c0-2.3-1.2-4.1-3.5-4.1z\" /><path d=\"M14 0v7h-1.5V1.5h-11v11H5V14H0V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol